/* eslint-disable */
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import makeStyles from '@material-ui/styles/makeStyles';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Box,
  Button,
  Link,
  TextField,
  InputAdornment,
  Tooltip
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { currentchannel } from 'feactures/channel/channelSlice';
import {
  fetchItemDetailGraph,
  itemDetailDisplay,
  setItemDetail,
  setItemDetailDisplayFlag
} from 'feactures/brand/brandRankSlice';
import ItemDetailDialogBrand from 'components/atoms/modal/ItemDetailDialogBrand';
import download_icon from '../../layout/dashboard/icons/download_icon.svg';
import {
  exportStatus_brandAnalysis,
  fetchExport_brandAnalysis
} from 'feactures/monitoring/exportSlice';

const BrandItemList = (props) => {
  const { top100items, yokoziku, section } = props;
  const exportStatus = useSelector(exportStatus_brandAnalysis);
  const dispatch = useDispatch();
  const combined = top100items.map((top100item, i) => ({
    rank: i + 1,
    ...top100item
  }));

  const [orderDesc, setOrderDesc] = useState(true);
  const [checkedColumn, setCheckedColumn] = useState('rank');
  const [sortArr, setSortArr] = useState(combined);
  const [searchWord, setSearchWord] = useState('');

  useEffect(() => {
    setOrderDesc(true);
    setCheckedColumn('rank');
    setSortArr(
      top100items.map((top100item, i) => ({
        rank: i + 1,
        ...top100item
      }))
    );
  }, [top100items]);

  const zenkakuToHankaku = (str) => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
  };

  useEffect(() => {
    if (searchWord === '') {
      const originalItems = top100items.map((top100item, i) => ({
        rank: i + 1,
        ...top100item
      }));
      if (orderDesc) {
        //降順
        if (checkedColumn === 'rank') {
          const descSorted = [...originalItems].sort(
            (a, b) => a[checkedColumn] - b[checkedColumn]
          );
          setSortArr(descSorted);
        } else {
          const descSorted = [...originalItems].sort(
            (a, b) => b[checkedColumn] - a[checkedColumn]
          );
          setSortArr(descSorted);
        }
      } else {
        //昇順
        if (checkedColumn === 'rank') {
          const ascSorted = [...originalItems].sort(
            (a, b) => b[checkedColumn] - a[checkedColumn]
          );
          setSortArr(ascSorted);
        } else {
          const ascSorted = [...originalItems].sort(
            (a, b) => a[checkedColumn] - b[checkedColumn]
          );
          setSortArr(ascSorted);
        }
      }
    } else {
      const originalItems = top100items.map((top100item, i) => ({
        rank: i + 1,
        ...top100item
      }));
      const hankakuSearchWord = zenkakuToHankaku(searchWord);
      const lowerCaseSearchWord = hankakuSearchWord.toLowerCase();
      const filtered = originalItems.filter((item) =>
        item.item_id.toString().toLowerCase().includes(lowerCaseSearchWord)
      );
      setSortArr(filtered);
    }
  }, [searchWord]);

  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  }));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const channel = useSelector(currentchannel);
  const displayFlag = useSelector(itemDetailDisplay);

  const url = 'https://m.media-amazon.com/images/I/';

  const handleChange = (column) => {
    if (column === checkedColumn && orderDesc === true) {
      //最後に並び替えたカラムと同じカラムで、現在の並び順が降順なので昇順に並び替える
      if (column === 'rank') {
        setOrderDesc(false);
        const ascSorted = [...sortArr].sort((a, b) => b[column] - a[column]);
        setSortArr(ascSorted);
      } else {
        setOrderDesc(false);
        const ascSorted = [...sortArr].sort((a, b) => a[column] - b[column]);
        setSortArr(ascSorted);
      }
    } else if (column === checkedColumn && orderDesc === false) {
      //最後に並び替えたカラムと同じカラムで、現在の並び順が昇順なので降順に並び替える
      if (column === 'rank') {
        setOrderDesc(true);
        const descSorted = [...sortArr].sort((a, b) => a[column] - b[column]);
        setSortArr(descSorted);
      } else {
        setOrderDesc(true);
        const descSorted = [...sortArr].sort((a, b) => b[column] - a[column]);
        setSortArr(descSorted);
      }
    } else {
      // 新しいカラムを降順に並び替える
      setCheckedColumn(column);
      if (column === 'rank') {
        setOrderDesc(true);
        const descSorted = [...sortArr].sort((a, b) => a[column] - b[column]);
        setSortArr(descSorted);
      } else {
        setOrderDesc(true);
        const descSorted = [...sortArr].sort((a, b) => b[column] - a[column]);
        setSortArr(descSorted);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const tableStyles = makeStyles({
    tableHead: {
      height: 44
    }
  });

  const classes = tableStyles();

  const handleClick = (row, shop_code) => {
    let item_id = row.item_id;
    if (channel == 2) {
      item_id = row.item_id.split(':')[1];
    }
    const data = {
      rank: row.rank,
      img: row.img,
      shopCode: shop_code,
      asin: item_id,
      item_name: row.name,
      price: row.price,
      unit_sold: row.unit_sold,
      sales: row.sales,
      section
    };
    dispatch(setItemDetailDisplayFlag(true));
    dispatch(setItemDetail(data));
    dispatch(fetchItemDetailGraph(data));
  };

  const handleChangeWord = (e) => {
    setSearchWord(e.target.value.toString());
  };
  return (
    <>
      {/* <Paper sx={{ width: '100%', overflow: 'hidden' }}> */}
      <ItemDetailDialogBrand yokoziku={yokoziku} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <TextField
          hiddenLabel
          id="outlined-basic"
          // label="Outlined"
          // variant="outlined"
          size="small"
          placeholder={channel == 1 ? 'ASIN検索' : '商品管理番号検索'}
          onChange={(e) => {
            handleChangeWord(e);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          sx={{ mb: 1 }}
        />
        <Tooltip
          title={
            exportStatus
              ? 'CSVダウンロード中...'
              : top100items.length == 0
              ? ''
              : 'CSVダウンロード'
          }
          placement="top"
        >
          <span>
            <IconButton
              onClick={() => {
                dispatch(fetchExport_brandAnalysis());
              }}
              disabled={exportStatus || top100items.length == 0}
            >
              <img
                src={download_icon}
                alt="ダウンロード"
                style={{ width: '20px' }}
              />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      <TableContainer sx={{ maxHeight: 550 }} component={Paper}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead sx={{ maxHeight: '38px' }}>
            <TableRow>
              {/* <TableCell sx={{ width: '62px' }} component="th" scope="row"> */}
              {/* 画像 */}
              <TableCell
                sx={{
                  width: sortArr.length !== 0 ? '70px' : '150px',
                  bgcolor: '#D9D9D9',
                  fontWeight: 'bold'
                }}
              ></TableCell>
              {channel == 1 ? (
                <TableCell
                  align="center"
                  sx={{ bgcolor: '#D9D9D9', fontWeight: 'bold' }}
                >
                  ASIN
                </TableCell>
              ) : (
                <TableCell
                  align="center"
                  sx={{ bgcolor: '#D9D9D9', fontWeight: 'bold' }}
                >
                  商品管理番号
                </TableCell>
              )}
              <TableCell
                align="center"
                sx={{ bgcolor: '#D9D9D9', fontWeight: 'bold' }}
              >
                商品名
              </TableCell>
              <TableCell
                align="center"
                sx={{ minWidth: '120px', padding: 0, bgcolor: '#D9D9D9' }}
              >
                <Button
                  onClick={() => {
                    handleChange('price');
                  }}
                  color="inherit"
                  sx={{
                    padding: 0,
                    height: '32.5px',
                    width: '100%',
                    fontWeight: 'bold'
                  }}
                >
                  平均価格
                  {checkedColumn !== 'price' && (
                    <Box width="20.5px" height="20.5px"></Box>
                  )}
                  {checkedColumn === 'price' && (
                    <ExpandMore
                      expand={orderDesc}
                      aria-expanded={orderDesc}
                      aria-label="sort"
                      sx={{ padding: 0 }}
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  )}
                </Button>
              </TableCell>
              <TableCell
                align="center"
                sx={{ minWidth: '120px', padding: 0, bgcolor: '#D9D9D9' }}
              >
                <Button
                  onClick={() => {
                    handleChange('unit_sold');
                  }}
                  color="inherit"
                  sx={{
                    padding: 0,
                    height: '32.5px',
                    width: '100%',
                    fontWeight: 'bold'
                  }}
                >
                  販売個数
                  {checkedColumn !== 'unit_sold' && (
                    <Box width="20.5px" height="20.5px"></Box>
                  )}
                  {checkedColumn === 'unit_sold' && (
                    <ExpandMore
                      expand={orderDesc}
                      aria-expanded={orderDesc}
                      aria-label="sort"
                      sx={{ padding: 0 }}
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  )}
                </Button>
              </TableCell>
              <TableCell
                align="center"
                sx={{ minWidth: '120px', padding: 0, bgcolor: '#D9D9D9' }}
              >
                <Button
                  onClick={() => {
                    handleChange('rank');
                  }}
                  color="inherit"
                  sx={{
                    padding: 0,
                    height: '32.5px',
                    width: '100%',
                    fontWeight: 'bold'
                  }}
                >
                  {checkedColumn !== 'rank' && (
                    <Box width="20.5px" height="20.5px"></Box>
                  )}
                  売上
                  {checkedColumn === 'rank' && (
                    <ExpandMore
                      expand={orderDesc}
                      aria-expanded={orderDesc}
                      aria-label="sort"
                      sx={{ padding: 0 }}
                    >
                      <ExpandMoreIcon />
                    </ExpandMore>
                  )}
                </Button>
              </TableCell>
              <TableCell sx={{ bgcolor: '#D9D9D9' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {combined.length !== 0 ? (
              <>
                {sortArr
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const shopCode =
                      channel == 2 ? row.item_id?.split(':')[0] : '';
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:nth-of-type(even)': { bgcolor: '#E3E8F4' },
                          height: 100
                        }}
                        className={classes.tableHead}
                      >
                        <TableCell align="center" maxwidth={40}>
                          <Link
                            href={
                              channel === 1
                                ? `https://www.amazon.co.jp/dp/${row.item_id}`
                                : `https://item.rakuten.co.jp/${shopCode}/${
                                    row.item_id?.split(':')[1]
                                  }/`
                            }
                            target="_blank"
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column'
                              }}
                            >
                              <Box
                                sx={{
                                  height: 70,
                                  width: 70,
                                  display: 'inline-block'
                                }}
                              >
                                <img
                                  src={channel == 1 ? url + row.img : row.img}
                                  height="100%"
                                  loading="lazy"
                                  width="100%"
                                />
                              </Box>
                            </Box>
                          </Link>
                        </TableCell>
                        <TableCell align="center">
                          <Box>
                            {channel == 1
                              ? row.item_id
                              : row.item_id?.split(':')[1]}
                          </Box>
                        </TableCell>
                        <TableCell align="left">
                          <Link
                            underline="hover"
                            href={
                              channel === 1
                                ? `https://www.amazon.co.jp/dp/${row.item_id}`
                                : `https://item.rakuten.co.jp/${shopCode}/${
                                    row.item_id?.split(':')[1]
                                  }/`
                            }
                            target="_blank"
                            rel="noopener"
                          >
                            <Box
                              sx={{
                                height: 60,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'left'
                                // width: 170,
                                // display: 'inline-block'
                              }}
                              component="div"
                              my={2}
                              textOverflow="ellipsis"
                              overflow="hidden"
                            >
                              {row.name}
                            </Box>
                          </Link>
                        </TableCell>
                        <TableCell align="right">
                          {row.price == 0
                            ? '-'
                            : '¥' + row.price.toLocaleString()}
                        </TableCell>
                        <TableCell align="right">
                          {row.unit_sold == 0
                            ? '-'
                            : row.unit_sold.toLocaleString()}
                        </TableCell>
                        <TableCell align="right">
                          {row.sales == 0
                            ? '-'
                            : '¥' + row.sales.toLocaleString()}
                        </TableCell>
                        {/* <TableCell align="right">
                          ¥{row.sales.toLocaleString()}
                        </TableCell> */}
                        <TableCell align="center">
                          <Button
                            variant="contained"
                            color="detailButton"
                            sx={{ fontWeight: 'bold', borderRadius: 160 }}
                            onClick={() => {
                              handleClick(row, shopCode);
                            }}
                          >
                            詳細
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </>
            ) : (
              <TableRow>
                <TableCell>データがありません</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 25, 100]}
        count={sortArr.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default BrandItemList;
